import React from "react";
import { DatePickerInput } from "rc-datepicker";

const normalizeDateValue = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export default class RenderField extends React.Component {
  render() {
    const {
      input,
      className
    } = this.props;

    const normalizedInput = {
      ...input,
      value: normalizeDateValue(input && input.value)
    };

    return (
      <DatePickerInput
        {...normalizedInput}
        className={className}
        showOnInputClick={true}
        showInputButton={false}
        minDate={new Date()}
        autoComplete="off"
      />
    );
  }
}
